

import React from 'react';
import ServiceForm from '../components/ServiceForm';
import { ArgumentsTable } from '../components/ArgumentsTable';
// import { CodeHighlighter } from '../components/CodeHighlighter';


const serviceEndpoint = "season/%sid/training-session/new";
const serviceArguments = [
  { name: 'date',     type: 'date',  mandatory: true, default: null, description: 'Training session date using format yyyy-mm-dd hh:ii:ss'},
  { name: 'cancelled', type: 'boolean',  mandatory: false, default: null, description: 'Set the training session as cancelled/not cancelled'},
  { name: 'players', type: 'array of player ids',  mandatory: false, default: null, description: 'Set the training session players'}
];

const serviceUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
];

const serviceSample = {
  'date'        : '2020-10-25 10:30:00',
  'players'     : [1,2,3,4,5]
}


export function TrainingSessionCreate() {
  return <TrainingSessionCreateComponent/>;
}


class TrainingSessionCreateComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>Create a new Training Session</h3>

                  <p>Endpoint: <b>{serviceEndpoint}</b></p>

                  <p>
                    This service can be used to create a basic Training Session, with no drills.<br/>
                    Players can be an empty array. It should contain, in general, a list of player ids.<br/>
                    See the service <i>Players</i> to get the list of players.
                    <br/>
                  </p>
                  
                  <ServiceForm
                        args={serviceArguments}
                        urlArgs={serviceUrlArguments}
                        sample={serviceSample}
                        endpoint={serviceEndpoint}
                        authRequired={true}
                        usePayload={true}
                  />

                  <h4>Request</h4>
                  <p>
                    A JSON with the match data
                  </p>
                  <ArgumentsTable args={serviceArguments} />
                  
                  <h4>Response</h4>
                  <p>
                    The created Training Session as JSON
                  </p>
                  
            </div>
        );
  }


} 